module.exports = __webpack_public_path__ + "static/img/供应链场景服务系统.dbd94d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/供应链场景服务系统.png
// module id = lkCM
// module chunks = 1